<template>
  <v-container>
    <v-row>
      <v-col cols="12" v-if="sectionTitle">
        <h4 class="kbDarkBlueText--text">
          {{ sectionTitle }}
        </h4>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        style="align-self: stretch!important"
        v-for="(header, index) in importerHeaders"
        :key="header.text + index"
      >
        <v-card class="kbWhite" style="height: 100%">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="customItems ? filteredItems(header.newText) : items"
                  item-value="value"
                  :label="$t('general.fieldName')"
                  v-model="header.newText"
                >
                  <template v-slot:item="{ item }">
                    <div class="pa-3">
                      <span class="kbDarkBlueText--text text-capitalize">
                        {{ item.text }}
                      </span>
                    </div>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="header.newText === 'other'">
                <v-text-field v-model="header.otherText"
                              :label="$t('general.newColumnName')"/>
              </v-col>

              <v-col style="min-height: 29px"
                     cols="12"
                     :class="color"
                     class="kbWhite--text">
                {{(header.newText === 'other') ? header.otherText : header.newText}}
              </v-col>

              <v-col cols="12"
                     v-for="(item, index) in importerPersons"
                     :key="index + item">
                {{item[header.text]}}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    selectedItemsValuesToHide () {
      const items = [...this.items]
      const mappedItemsValues = items.map(item => item.value)
      const selectedHeadersToHide = []
      for (const header of this.importerHeaders) {
        if (mappedItemsValues.includes(header.newText) && header.newText !== 'other') {
          selectedHeadersToHide.push(header.newText)
        }
      }
      return selectedHeadersToHide
    }
  },
  methods: {
    filteredItems (header) {
      const items = [...this.items]
      const headersValuesToHide = [...this.selectedItemsValuesToHide]
      const foundHeaderToRemoveIndex = headersValuesToHide.indexOf(header)
      if (foundHeaderToRemoveIndex !== -1) headersValuesToHide.splice(foundHeaderToRemoveIndex, 1)
      return items.filter(item => !headersValuesToHide.includes(item.value))
    }
  },
  props: {
    color: String,
    customItems: {
      type: Boolean,
      default: false
    },
    importerHeaders: {
      type: Array,
      required: true
    },
    importerPersons: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    sectionTitle: {
      type: String,
      default: ''
    }
  }
}
</script>
